import suvImg from "../assets/bodytypes/suv.webp";
import electricImg from "../assets/bodytypes/electric.webp";
import hatchbackImg from "../assets/bodytypes/hatchback.webp";
import estateImg from "../assets/bodytypes/estatewebp.webp";
import coupeImg from "../assets/bodytypes/coupe.webp";
import convertibleImg from "../assets/bodytypes/convertible.webp";
import saloonImg from "../assets/bodytypes/saloon.webp";
import mpvImg from "../assets/bodytypes/mpv.webp";
import panelVan from "../assets/bodytypes/panel van.png";
import highRoofPanelVan from "../assets/bodytypes/High panel van.png";

export const BODY_TYPES = [
  { key: "SUV", label: "SUV", seats: "5-7 seats", img: suvImg },
  {
    key: "ELECTRIC",
    label: "Electric",
    seats: "2-7 seats",
    img: electricImg,
  },
  {
    key: "HATCHBACK",
    label: "Hatchback",
    seats: "4-5 seats",
    img: hatchbackImg,
  },
  { key: "ESTATE", label: "Estate", seats: "5-7 seats", img: estateImg },
  { key: "COUPE", label: "Coupe", seats: "2-4 seats", img: coupeImg },
  {
    key: "CONVERTIBLE",
    label: "Convertible",
    seats: "2-5 seats",
    img: convertibleImg,
  },
  { key: "SALOON", label: "Saloon", seats: "4-5 seats", img: saloonImg },
  { key: "MPV", label: "MPV", seats: "5-7 seats", img: mpvImg },
  {
    key: "HIGH ROOF PANEL VAN",
    label: "High Roof Panel Van",
    seats: "9-15 seats",
    img: highRoofPanelVan,
  },
  {
    key: "PANEL VAN",
    label: "Panel Van",
    seats: "9-15 seats",
    img: panelVan,
  },
];
